import Service from '@ember/service';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import { saveRecord } from 'tio-data/requests/save-record';
import type { Store } from '@warp-drive/core';
import type SessionContextService from './session-context';
import type { AnswerProfileExtension as AnswerProfileModel } from 'tio-data/data/resources/answer-profile.ext';

export default class AnswerProfileService extends Service {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  storeAnswers = async (providingApp = 'DASHBOARD', answers = {}) => {
    let profile = this.sessionContext.user.answerProfile;

    if (!profile) {
      // @ts-expect-error not sure
      profile = await this.findOrCreateAnswerProfileForCurrentUser();
    }

    if (!profile) {
      throw new Error('Could not find or create answer profile');
    }

    profile.providingApp = providingApp;
    for (const key in answers) {
      // @ts-expect-error: Find out possible values.
      profile[key] = answers[key];
    }
    await saveRecord(this.store, profile);
    return profile;
  };

  findOrCreateAnswerProfileForCurrentUser = async () => {
    if (this.sessionContext.user.answerProfile) {
      return this.sessionContext.user.answerProfile;
    }

    const { content } = (await this.store.request(
      query<AnswerProfileModel>('answer-profile', {
        'filter[user]': this.sessionContext.user.id as string,
        include: 'user',
      })
    )) as { content: { data: AnswerProfileModel[] } };

    if (content.data.length) {
      return content.data[0];
    } else {
      const answerProfile = this.store.createRecord<AnswerProfileModel>('answer-profile', {
        // TODO:
        // Remove non-null constaint from tio-api / database.
        // The database requires a value for `providing_app` and it must be an enum value
        // and therefore we have to have some default here to avoid errors on save if no
        // additional value is provided. - Julia 03/06/2023
        providingApp: 'DASHBOARD',
        user: this.sessionContext.user,
      });
      return answerProfile;
    }
  };
}
